export function usePageTranslation(): {
	metaTitle: Ref<string>
	pageTitle: Ref<string>
	pageDescription: Ref<string>
} {
	const metaTitle = ref<string>('')
	const pageTitle = ref<string>('')
	const pageDescription = ref<string>('')

	function updatePageTranslation() {
		const viewComponent = getRouterContext().view.component

		metaTitle.value = t(`views.${viewComponent}.meta_title`)
		pageTitle.value = t(`views.${viewComponent}.title`)
		pageDescription.value = t(`views.${viewComponent}.description`)
	}

	updatePageTranslation()
	registerHook('navigated', updatePageTranslation)

	return {
		metaTitle,
		pageTitle,
		pageDescription,
	}
}
